class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopHoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.closeTimeout = null;

    this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    this.addEventListener('keyup', this.handleKeyUp.bind(this));
    this.content.addEventListener('mouseenter', this.handleContentMouseEnter.bind(this));
    this.content.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', this.mainDetailsToggle.open);
    if (this.mainDetailsToggle.open) this.closeSiblingMenus();
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    this.clearCloseTimeout();
    super.close();
  }

  handleMouseEnter() {
    this.clearCloseTimeout();
    if (!this.desktopHoverMediaQuery.matches || this.mainDetailsToggle.open) return;

    this.closeSiblingMenus();
    this.mainDetailsToggle.open = true;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  handleContentMouseEnter() {
    this.clearCloseTimeout();
  }

  handleMouseLeave() {
    if (!this.desktopHoverMediaQuery.matches || !this.mainDetailsToggle.open) return;
    this.clearCloseTimeout();
    this.closeTimeout = window.setTimeout(() => {
      this.close();
    }, 180);
  }

  handleKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.close();
    this.mainDetailsToggle.querySelector('summary').focus();
  }

  closeSiblingMenus() {
    const openMenus = this.closest('.header')?.querySelectorAll('header-menu details[open]');

    openMenus?.forEach((menu) => {
      if (menu === this.mainDetailsToggle) return;

      menu.removeAttribute('open');
      menu.querySelector('summary').setAttribute('aria-expanded', false);
    });
  }

  clearCloseTimeout() {
    if (!this.closeTimeout) return;
    window.clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }
}

customElements.define('header-menu', HeaderMenu);
